import { render, staticRenderFns } from "./LicenseTypeDetails.vue?vue&type=template&id=c8720cb0&"
import script from "./LicenseTypeDetails.vue?vue&type=script&lang=js&"
export * from "./LicenseTypeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports